import InviteCodePopover from './InviteCodePopover'

export default InviteCodePopover



// WEBPACK FOOTER //
// ./src/components/organisms/InviteCodePopover/index.js